/**
 * Human-readable message for an ApiResponse error envelope.
 *
 * VALIDATION_ERROR responses carry the user-actionable text under
 * `details.issues[]`; the top-level `message` is just "Validation error" —
 * expand the issues so users see which field failed and why. Lifted from
 * StoryCards for reuse by every admin surface.
 */
export function formatApiError(
  err: { code?: string; message?: string; details?: unknown } | undefined,
  fallback = 'Something went wrong. Please try again.'
): string {
  if (!err) return fallback;
  if (
    err.code === 'VALIDATION_ERROR' &&
    err.details &&
    typeof err.details === 'object' &&
    'issues' in err.details
  ) {
    const issues = (err.details as { issues?: { path?: string; message?: string }[] }).issues;
    if (issues && issues.length > 0) {
      return issues
        .map((i) => (i.path ? `${i.path}: ${i.message ?? 'invalid'}` : (i.message ?? 'invalid')))
        .join('\n');
    }
  }
  return err.message || fallback;
}
